import type { Feature } from '../../../plan/types';

export const abTestsAndExperiments: Feature = { text: 'A/B tests and experiments' };
export const advancedUserTargeting: Feature = { text: 'Advanced user targeting' };
export const customAIRuns: Feature = { text: 'Custom AI runs' };
export const customRolesTeams: Feature = { text: 'Custom roles & teams' };
export const developerPlus: Feature = { text: 'Everything in Developer, plus:' };
export const fiveKSessionReplaysAndErrors: Feature = { text: '5K session replays and errors' };
export const fiveThousandAIRuns: Feature = { text: '5,000 AI runs' };
export const foundationPlus: Feature = { text: 'Everything in Foundation, plus:' };
export const fourteenDayRetention: Feature = { text: '14 days data retention' };
export const hundredDayRetention: Feature = { text: '100 days data retention' };
export const noOverages: Feature = { text: 'No overages' };
export const releaseAssistant: Feature = { text: 'Release assistant' };
export const releaseAutomation: Feature = { text: 'Release automation' };
export const samlScim: Feature = { text: 'SAML / SCIM' };
export const scalableExperimentation: Feature = { text: 'Scalable experimentation usage' };
export const scalableObservability: Feature = { text: 'Scalable observability usage' };
export const sso: Feature = { text: 'Single sign on' };
export const tenMLogsAndTraces: Feature = { text: '10M logs and traces' };
export const thirtyDayRetention: Feature = { text: '30 days data retention' };
export const thirtyIdiomaticSdks: Feature = { text: '30 idiomatic SDKs' };
export const unlimitedDatasets: Feature = { text: 'Unlimited datasets' };
export const unlimitedFeatureFlags: Feature = { text: 'Unlimited feature flags' };
export const unlimitedOfflineEvals: Feature = { text: 'Unlimited offline evals' };
export const unlimitedPlaygrounds: Feature = { text: 'Unlimited playgrounds' };
export const unlimitedProjects: Feature = { text: 'Unlimited projects' };
export const unlimitedSeats: Feature = { text: 'Unlimited seats' };
export const usageBasedAIRunsPricing: Feature = { text: 'Usage-based pricing past 5,000 AI runs/mo' };
export const userTargeting: Feature = { text: 'User, account, device targeting' };
export const workflowsSchedulingApprovals: Feature = { text: 'Workflows, scheduling, & approvals' };
